/** 
 * buildinfo.js contains the build version for CMSView. This 
 * marks the build of CMSView running on dev, test, or prod. 
 */
export const buildnum = ts_temp___build_num();







export const buildinfo = { buildnum };

console.log("BUILD:" + buildnum);



// WEBPACK FOOTER //
// ./js/buildinfo.js